export const Anchor = {
  ContactUs: 'contactUs',
  OurReview: 'ourReview',
  Inspect: 'inspectAnchor',
  RtpReviews: 'casinoRtpReviews',
  CasinoReviews: 'casinoReviewsAnchor',
  Main: 'mainAnchor',
  CasinoComplaints: 'casinoComplaintsAnchor',
  CasinoDetails: 'casinoDetailsAnchor',
  SavedCasinos: 'savedCasinosAnchor',
  StreamerReviews: 'streamerReviewsAnchor',
  StreamerDetails: 'streamerDetailsAnchor',
  FAQ: 'FAQ',
  OurMission: 'ourMissionAnchor',
  AboutUsSearch: 'aboutUsSearchAnchor',
  Support: 'aboutUsSupportAnchor',
  OurTeam: 'aboutUsOurTeamAnchor',
  GuidesCategoryCasino: 'guidesCategoryCasinoAnchor',
  GuidesCategorySlots: 'guidesCategorySlotsAnchor',
  GuidesCategoryRtpChecks: 'guidesCategoryRtpChecksAnchor',
  GuidesCategoryOther: 'guidesCategoryOtherAnchor',
  WriteComment: 'writeCommentAnchor',
  Bigwins: 'bigwinsAnchor',
  Topics: 'topicsAnchor',
  NewsBlogs: 'newsBlogsAnchor',
  NewsRTPChecks: 'newsRTPChecksAnchor',
  NewsBigwins: 'newsBigwinsAnchor',
  News: 'newsAnchor',

  slot: {
    demo: 'play-demo',
    checkRTP: 'check-rtp',
    bigWins: 'big-wins',
    forMoney: 'for-money',
    faq: 'faq',
    reviews: 'reviews',
  },
};
